import { Grid, TextField } from "@material-ui/core";
import { useContentPageContext } from "@providers/ContentPageProvider";
import React from "react";

function ContentPageSEO() {
  const { contentPage, setContentPage } = useContentPageContext();
  const handleChange = (e) => {
    setContentPage({
      ...contentPage,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <form noValidate autoComplete="off">
      <Grid container spacing={3} direction="column">
        <Grid item xs={4}>
          <TextField
            name="seoTitle"
            onChange={handleChange}
            value={contentPage.seoTitle || ""}
            fullWidth
            size="small"
            label="Title"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={7}>
          <TextField
            name="seoDescription"
            onChange={handleChange}
            value={contentPage.seoDescription || ""}
            fullWidth
            multiline
            size="small"
            minRows={3}
            maxRows={6}
            label="Description"
            variant="outlined"
          />
        </Grid>
      </Grid>
    </form>
  );
}

export default ContentPageSEO;
